/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2018 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/

import React from "react";
import { AccessibleListItemNode } from "./AccessibleListItemNode";
import AccessibilityCss from "./Accessibility.css";
import { getRelativeNodePosition } from "./AccessibilityComponentHelper";

export const renderListChildren = (list, zoomLevel, pageIndex) =>
  list.children.map((child, index) => {
    const style = getRelativeNodePosition(child.contentRect, list.contentRect, pageIndex);
    return (
      <AccessibleListItemNode
        style={style}
        item={child}
        key={`listitem${index}`}
        zoomLevel={zoomLevel}
        pageIndex={pageIndex}
      />
    );
  });

export const AccessibleListNode = ({ style, list, zoomLevel, pageIndex }) => {
  if (!list.children) return null;
  const children = renderListChildren(list, zoomLevel, pageIndex);
  return (
    <ul style={style} className={AccessibilityCss.listNode}>
      {children}
    </ul>
  );
};
